import { Injectable } from '@angular/core';
import { AppConstants } from '../common/app.constants'
import { StorageService } from '../common/services/storage.service';


@Injectable({
    providedIn: 'root'
})
export class PermissionService {



    pagePermissionMaping: any[] = [
        { page: "job-position-edit", parent: "job-position" },
        { page: "department-edit", parent: "department" },
        { page: "employee-type-edit", parent: "employee-type" },
        { page: "task-edit", parent: "task" },
        { page: "shift-edit", parent: "shift" },
        { page: "job-title-edit", parent: "job-title" },
        { page: "leave-type-edit", parent: "leave-type" },
        { page: "reason-edit", parent: "reason" },
    ];



    constructor(private storageService: StorageService) { }


    /**
     * Returns the page permission for currenmtly loged in user
     * @param page 
     * @returns 
     */
    getPagePermission(page: string): any {
        let sesUser = this.storageService.loadFromSession(AppConstants.SESSION_VAR_USER);
        const users = (sesUser !== null) ? JSON.parse(sesUser) : { id: 0 };
        const permissionArr = users.permissions;
        const pagePermission = permissionArr.find((perm: any) => perm.page == page);
        return (pagePermission) ? pagePermission.permission : this.getDefaultPermission(page);
        // return {
        //     "can_view": 1,
        //     "can_add": 1,
        //     "can_edit": 1,
        //     "can_delete": 1,
        //     "can_execute": 1,
        //     "can_publish": 1,
        //     "can_export": 1,
        //     "can_import": 1,

        // };
    }

    getRowPermission(pagePermission: any, rowId: any): any {

        let sesUser = this.storageService.loadFromSession(AppConstants.SESSION_VAR_USER);
        const user = (sesUser !== null) ? JSON.parse(sesUser) : { id: 0 };
        let rowPermission = JSON.parse(JSON.stringify(pagePermission));
        if (user.user_type == 'SHOP' && (rowId < AppConstants.MASTER_ID_MULTI_FACTOR && rowId > 0)) {
            rowPermission.can_edit = 0;
            rowPermission.can_delete = 0;
        }
        return rowPermission;
    }
    /**
     * Returns the list of permissions for the currently logged in user
     * @returns 
     */

    getPermission(): any {

        let sesUser = this.storageService.loadFromSession(AppConstants.SESSION_VAR_USER);
        const users = (sesUser !== null) ? JSON.parse(sesUser) : { id: 0 };
        const permissionArr = users.permissions;
        return permissionArr;
    }

    /**
     * Returns the currently logged in user info
     * @returns 
     */
    getCurrentUser(): any {
        let sesUser = this.storageService.loadFromSession(AppConstants.SESSION_VAR_USER);
        return (sesUser !== null) ? JSON.parse(sesUser) : { id: 0, user_type: '' };
    }

    /**
     * The default permission is to view the content
     * @returns 
     */
    getDefaultPermission(page: string): any {
        const parentPage = this.pagePermissionMaping.find((pg: any) => pg.page == page);
        if (parentPage) {
            return this.getPagePermission(parentPage.parent);
        }

        let sesUser = this.storageService.loadFromSession(AppConstants.SESSION_VAR_USER);
        const user = (sesUser !== null) ? JSON.parse(sesUser) : { id: 0, user_type: '' };
        if (user && user.user_type === 'HQ') {
            return {
                "can_view": 1,
                "can_add": 1,
                "can_edit": 1,
                "can_delete": 1,
                "can_execute": 1,
                "can_publish": 1,
                "can_export": 1,
                "can_import": 1,
            };
        }

        var permission: any = {
            "can_view": 0,
            "can_add": 0,
            "can_edit": 0,
            "can_delete": 0,
            "can_execute": 0,
            "can_publish": 0,
            "can_export": 0,
            "can_import": 0,
        };
        return permission;
    }

    /**
     * Returns the permission set for the action
     * @param page 
     * @param action 
     * @returns 
     */
    hasPermission(page: string, action: string): boolean {

        const permission = this.getPagePermission(page);

        var hasPermission = 0;
        switch (action) {
            case 'view':
                hasPermission = permission.can_view;
                break;
            case 'add':
                hasPermission = permission.can_add;
                break;
            case 'edit':
                hasPermission = permission.can_edit;
                break;
            case 'delete':
                hasPermission = permission.can_delete;
                break;
            case 'execute':
                hasPermission = permission.can_execute;
                break;
            case 'publish':
                hasPermission = permission.can_publish;
                break;
            case 'export':
                hasPermission = permission.can_export;
                break;
        }
        return (hasPermission == 1) ? true : false;
        // return true;

    }

    /**
     * Returns data-level permission for the given key (e.g. 'attendance', 'shift', 'wages-cost', 'sales')
     * @param permissionKey 
     * @param functionCode optional function/module code, default 'roster'
     * @returns { can_view: number, can_edit: number }
     */
    getDataPermission(permissionKey: string, functionCode: string = 'roster'): { can_view: number, can_edit: number } {
        const user = this.getCurrentUser();

        // Shift can_view is always 1 (true)
        if (permissionKey === 'shift') {
            let canEdit = 1;
            if (user && user.data_permissions) {
                const dp = user.data_permissions;
                if (dp[functionCode] && dp[functionCode]['shift']) {
                    canEdit = Number(dp[functionCode]['shift'].can_edit) || 0;
                } else if (Array.isArray(dp)) {
                    const match = dp.find((p: any) => p.permission === 'shift' && (!functionCode || p.function_code === functionCode || p.wfm_system_function_id === 10));
                    if (match) canEdit = Number(match.can_edit) || 0;
                }
            } else if (user && user.user_type !== 'HQ') {
                canEdit = 0;
            }
            return { can_view: 1, can_edit: canEdit };
        }

        if (!user) {
            return { can_view: 0, can_edit: 0 };
        }

        const dp = user.data_permissions;
        if (dp) {
            const scope = dp[functionCode] || dp;
            let match = scope ? scope[permissionKey] : null;
            if (!match && scope && (permissionKey === 'wages-cost' || permissionKey === 'wage-cost' || permissionKey === 'wages/cost')) {
                match = scope['wages-cost'] || scope['wage-cost'] || scope['wages/cost'];
            }
            if (match) {
                return {
                    can_view: Number(match.can_view) || 0,
                    can_edit: Number(match.can_edit) || 0
                };
            } else if (Array.isArray(dp)) {
                const match = dp.find((p: any) => 
                    (p.permission === permissionKey || 
                     ((permissionKey === 'wages-cost' || permissionKey === 'wage-cost' || permissionKey === 'wages/cost') && 
                      (p.permission === 'wages-cost' || p.permission === 'wage-cost' || p.permission === 'wages/cost'))) &&
                    (!functionCode || p.function_code === functionCode || p.wfm_system_function_id === 10)
                );
                if (match) {
                    return {
                        can_view: Number(match.can_view) || 0,
                        can_edit: Number(match.can_edit) || 0
                    };
                }
            }
        }

        // Default for HQ user if no data_permissions found
        if (user.user_type === 'HQ') {
            return { can_view: 1, can_edit: 1 };
        }

        return { can_view: 0, can_edit: 0 };
    }

    /**
     * Modify and filter permissions before setting to session storage
     */
    validatePermission(user: any): any {
        if (!user || !user.permissions) return user;

        const userType = user.user_type;

        // 1. Convert permissions to a working array (handles PHP's associative array vs standard array)
        let permissionsArr = Array.isArray(user.permissions) ? user.permissions : Object.values(user.permissions);

        // 2. Filter permissions based on the 'available_in' user type list
        permissionsArr = permissionsArr.filter((permObj: any) => {
            // Skip the index-0 empty array often found in this backend's response
            if (Array.isArray(permObj) && permObj.length === 0) return false;

            if (permObj && permObj.page && Array.isArray(permObj.available_in)) {
                return permObj.available_in.includes(userType);
            }
            // If it's a valid permission object but missing available_in, keep it by default unless it's definitely invalid
            return !!(permObj && permObj.page);
        });

        // 3. For non-HQ users (SHOP, AREA_MANAGER), strip certain rights based on allowed_list
        if (userType !== 'HQ') {
            // const restrictedPages: any[] = [
            //     { page: 'sale-item', can_add: 0, can_edit: 1, can_delete: 1 },
            //     { page: 'item-class', can_add: 0, can_edit: 1, can_delete: 1 },
            //     { page: 'combo', can_add: 0, can_edit: 1, can_delete: 1 },
            //     { page: 'customization', can_add: 0, can_edit: 1, can_delete: 1 }
            // ];

            // permissionsArr.forEach((permObj: any) => {
            //     if (permObj.permission) {
            //         const allowedPage = restrictedPages.find(p => p.page === permObj.page);
            //         if (!allowedPage) {
            //             // permObj.permission.can_add = 0;
            //             // permObj.permission.can_edit = 0;
            //             // permObj.permission.can_delete = 0;
            //         } else {
            //             if (allowedPage.can_add !== undefined) permObj.permission.can_add = (allowedPage.can_add && permObj.permission.can_add) ? 1 : 0;
            //             if (allowedPage.can_edit !== undefined) permObj.permission.can_edit = (allowedPage.can_edit && permObj.permission.can_edit) ? 1 : 0;
            //             if (allowedPage.can_delete !== undefined) permObj.permission.can_delete = (allowedPage.can_delete && permObj.permission.can_delete) ? 1 : 0;
            //         }
            //     }
            // });
        }

        user.permissions = permissionsArr;
        return user;
    }

}
